<div class="row">
    <div class="col-lg-12">
        <ngb-pagination class="pagination pagination-rounded justify-content-center mt-3" [collectionSize]="totalCount" [maxSize]="4" [page]="pageNumber"
        [rotate]="true" [ellipses]="false" [boundaryLinks]="true" (pageChange)="change($event)"></ngb-pagination>
    </div>
</div>